var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.answers.length)?_c('div',{staticClass:"p-3",attrs:{"id":"keyword-answers"}},[_c('div',{staticClass:"title mb-2"},[_vm._v("Answer")]),_vm._l((_vm.answers),function(text){return _c('div',{key:text,staticClass:"body",on:{"click":function($event){return _vm.handleLinkClick(text)}}},[_vm._v("\n     "+_vm._s(text)+"\n  ")])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }